import { AssetMaintenanceRowsServiceBase } from './asset-maintenance-rows.service.base';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT, HateoasMultipleResponseObject, PageSpecification } from '@scisys-uim/uim-common';
import { AssetMaintenance } from 'assets-model';
import { Observable } from 'rxjs';


export abstract class AssetMaintenanceRowsServiceCommon<G> extends AssetMaintenanceRowsServiceBase<G> {
  constructor(http: HttpClient, @Inject(ENVIRONMENT) environment: any) {
    super(http, environment);
  }
  // methods shared across subclasses for different group keys
}

@Injectable({
  providedIn: 'root'
})
export class AssetMaintenanceRowsService extends AssetMaintenanceRowsServiceCommon<any> {
  constructor(http: HttpClient, @Inject(ENVIRONMENT) environment: any) {
    super(http, environment);
  }

  public findAllInGroup(key: any, pageSpec?: PageSpecification): Observable<HateoasMultipleResponseObject<AssetMaintenance>> {
    return this.findByFullFilters(key, pageSpec);
  }
}



